import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { EventsWebsocketService } from "../../services/entities/events-websocket.service";
import { networkActions } from "./network.actions";
import {map, withLatestFrom} from "rxjs";
import { appStarted } from "../auth/auth.actions";
import {Store} from "@ngrx/store";
import {selectConnectedSocketNamespaces, selectNetworkReady} from "./network.selector";
import {NetworkConnectedState} from "./network-states.enum";

export const connect = createEffect(
  (actions$ = inject(Actions), websocketService = inject(EventsWebsocketService)) => {
    return actions$.pipe(
      ofType(networkActions.connect, appStarted),
      map((action) => {
      }),
    );
  },
  { functional: true, dispatch: false },
);

export const disconnect = createEffect(
  (actions$ = inject(Actions), websocketService = inject(EventsWebsocketService)) => {
    return actions$.pipe(
      ofType(networkActions.disconnect),
      map((action) => {
        websocketService.disconnect();
      }),
    );
  },
  { functional: true, dispatch: false },
);

export const respondToConnect = createEffect(
    (
        actions$ = inject(Actions),
        store = inject(Store),
    ) => {
        return actions$.pipe(
            ofType(networkActions.socketConnected),
            withLatestFrom(store.select(selectConnectedSocketNamespaces)),
            map((action) => {
               let namespaces = action[1]
            }),
        );
    },
    { functional: true, dispatch: false },
);

